import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import TablePriceReviewComponent from '../components/TablePriceReviewComponent';
import PriceComparisonTabs from '../components/PriceComparisonTabs';
import { validateSession } from '../utils/functions';

var config = process.env;

// Revisión de precios contra el proveedor.
//
// Pantalla propia y NO parte del Monitor de Stock: el monitor es sobre reposición (qué pedir) y
// esto es sobre precios (qué cobrar). Son dos trabajos distintos, con cadencias distintas —
// el monitor se mira todos los días, esto una vez por semana.
class PriceReviewPage extends Component {

    constructor() {
        super();
        this.state = {
            checked: false,
            role: 0,
            rows: [],
            syncStatus: null,
            loaded: false,
            loadError: false,
            featureOff: false
        };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role });
        this.load();
    }

    load = () => {
        this.setState({ loaded: false });
        Promise.all([this.fetchReview(), this.fetchSyncStatus()])
            .then(([rows, syncStatus]) => this.setState({ rows, syncStatus, loaded: true }))
            // Sin esto, un 502 durante un deploy (res.json() sobre HTML) rechaza la promesa, el
            // `then` nunca corre y la pantalla queda con el spinner para siempre.
            .catch(() => this.setState({ rows: [], loaded: true, loadError: true }));
    }

    fetchReview = () => {
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'supplier-sync/price-review', request)
        .then(res => res.json())
        .then(data => {
            if (data.error === 6604) {
                // Feature apagado: se avisa en la pantalla, sin alert.
                this.setState({ featureOff: true });
                return [];
            }
            if (data.error > 0) {
                alert(data.message);
                if (data.error === 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
                return [];
            }
            return data.data || [];
        });
    }

    fetchSyncStatus = () => {
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        };
        return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'supplier-sync/status', request)
        .then(res => res.json())
        .then(data => (data.error > 0 ? null : data.data))
        .catch(() => null);
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }

        const { syncStatus, rows, loaded } = this.state;
        const lastRun = syncStatus && syncStatus.lastRun;

        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={39} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4" style={{ paddingBottom: '80px' }}>
                            <HeaderComponent title="Comparativa de precios" subtitle="Contra el proveedor (SACCUM)" />
                            <PriceComparisonTabs active="saccum" />

                            <div className="mb-3 px-1" style={{ fontSize: '13px' }}>
                                <span className="text-muted">
                                    Comparación entre nuestro precio de venta y el precio de lista que publica SACCUM.
                                    {lastRun && (
                                        <> Datos del proveedor al {new Date(lastRun.startedAt).toLocaleString('es-UY', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}.</>
                                    )}
                                </span>
                            </div>

                            {!loaded && (
                                <div className="containerLoader">
                                    <div className="loader"></div>
                                </div>
                            )}

                            {loaded && this.state.featureOff && (
                                <div className="alert alert-secondary">
                                    El sync con el proveedor está desactivado. Se activa desde
                                    Configuración &gt; Feature flags.
                                </div>
                            )}

                            {loaded && !this.state.featureOff && this.state.loadError && (
                                <div className="alert alert-warning">
                                    No se pudieron cargar los precios. Probá recargar la página.
                                </div>
                            )}

                            {loaded && !this.state.loadError && !this.state.featureOff && (
                                <TablePriceReviewComponent rows={rows} onChange={this.load} />
                            )}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default PriceReviewPage;
